module.exports = __webpack_public_path__ + "static/media/drag-city-combined-iphonex1.03f7f5aa.png";